module.exports = __webpack_public_path__ + "static/img/1_3_2.1dfd2d13.jpg";